import { connect } from 'react-redux';
import { exitDuperbrowse } from '../../../Duperbrowse/redux/actionCreators';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
const mapStateToProps = (state)=>({
        currentDuperbrowseItem: getCurrentItem(state)
    });
const mapDispatchToProps = {
    exitDuperbrowse
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=BackButton.container.js.map